module.exports = __webpack_public_path__ + "static/img/13.5f1defb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/13.png
// module id = 4eH+
// module chunks = 0